<template>
  <ButtonSecondary class="flex items-center">
    <IconHeroiconsSolidPlus class="mr-1" />
    <slot />
  </ButtonSecondary>
</template>
